<template lang='html'>
  <d-container fluid class='main-content-container px-3'>
    <d-row class="mb-4">
       <d-col cols="auto" class="d-flex mb-4 mb-sm-0 justify-content-start">
          <d-input-group size="sm" class="date-range d-flex justify-content-left">
            <d-datepicker v-model="dateRange.from" :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }" placeholder="Data inicial" typeable small />
            <d-datepicker v-model="dateRange.to" :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }" placeholder="Data final" typeable small />
            <d-input-group-text slot="append">
              <i class="material-icons">&#xE916;</i>
            </d-input-group-text>
          </d-input-group>
          <d-button type="button" @click.prevent="getResellerStats" size="sm" class="d-flex btn-primary ml-3 mr-sm-0 mt-3 mt-sm-0">Filtrar</d-button>
          <d-button type="button" @click.prevent="clear" size="sm" class="d-flex btn-info ml-3 mr-sm-0 mt-3 mt-sm-0">Limpar</d-button>
        </d-col>
    </d-row>
    <!-- Small Stats Blocks -->
    <d-row>
      <d-col lg v-for='(stats, idx) in smallStats' :key='idx' class='mb-4'>
        <small-stats :id='`small-stats-${idx}`' variation='1' :chart-data='stats.datasets' :label='stats.label' :value='stats.value' :percentage='stats.percentage' :increase='stats.increase' :decrease='stats.decrease' />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import SmallStats from '_common/components/dashboard/SmallStats.vue';
import ResellerService from '_services/rest/modules/reseller';

export default {
  name: 'reseller-indicators',
  components: {
    SmallStats,
  },
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      smallStats: [],
      dateRange: {
        from: null,
        to: null,
      },
    };
  },
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    clear() {
      this.dateRange = {
        from: null,
        to: null,
      };
    },
    getResellerStats() {
      this.setToggle({ type: 'progress', bool: true });
      ResellerService.getIndicators(this.id, this.dateRange)
        .then(response => {
          this.setToggle({ type: 'progress', bool: false });
          this.smallStats = response;
        });
    },
  },
  mounted() {
    if (this.id) {
      this.getResellerStats();
    }
  },
};
</script>

<style lang='scss' scoped >
.input-group-sm /deep/ {
  .vdp-datepicker {
    input.form-control {
      height: 1.97rem!important;
    }
  }
}
</style>
